var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_17259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#3583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 12.0033C23.9997 18.6314 18.6278 24.0033 11.9997 24.0033C10.0218 24.0046 8.07438 23.5165 6.33096 22.5825C4.58755 21.6485 3.10236 20.2975 2.00781 18.6502C8.87172 18.5461 11.5998 14.4033 11.5998 14.4033C15.505 8.49703 20.2783 7.23656 22.9239 7.03125C23.6356 8.59203 24.0026 10.2879 23.9997 12.0033Z",
    fill: "#3583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6712 17.4979C21.6691 19.4424 20.1547 21.0761 18.2916 22.2226C16.4285 23.369 14.2876 23.9846 12.1001 24.0028C9.91257 24.0211 7.76168 23.4413 5.87973 22.3261C3.99778 21.2108 2.45632 19.6026 1.42188 17.6751C3.85937 18.3032 8.04062 18.9538 10.8644 17.0699C10.8644 17.0699 18.078 11.646 22.6712 17.4979Z",
    fill: "#3583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2969 11.1133C13.2969 10.3949 12.7145 9.8125 11.9961 9.8125C11.2777 9.8125 10.6953 10.3949 10.6953 11.1133V16.7955C10.6953 17.5139 11.2777 18.0963 11.9961 18.0963C12.7145 18.0963 13.2969 17.5139 13.2969 16.7955V11.1133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 8.79373C11.7132 8.7954 11.4332 8.71214 11.1947 8.55452C10.9561 8.3969 10.7698 8.17201 10.6592 7.90835C10.5486 7.64469 10.5188 7.35414 10.5736 7.07352C10.6283 6.79291 10.7652 6.53487 10.9668 6.33211C11.1683 6.12935 11.4256 5.99101 11.7058 5.93462C11.9861 5.87822 12.2769 5.90632 12.5412 6.01534C12.8055 6.12436 13.0314 6.3094 13.1905 6.547C13.3495 6.7846 13.4344 7.06407 13.4344 7.34998C13.435 7.73161 13.2842 8.09792 13.0152 8.36857C12.7461 8.63922 12.3807 8.79211 11.9991 8.79373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_17259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.847efbeb9ea22c988986e66a76d68830.svg";
export { ForwardRef as ReactComponent };